export default "__VITE_ASSET__DPcm5$N___"